import * as React from 'react';
import { useState } from 'react';
import styled, { createGlobalStyle, keyframes } from 'styled-components';
import Filter from './Filter';
import { __ } from '@bart.sk-eshop/react-i18n';
import { useFilter } from '../../hooks/filter';
import { PRODUCTS_PER_PAGE, UrlMapTypes } from '../../constants';
import { isFurnitureSection } from '../../components/_layout/Header/HeaderNew/menuData';
import { connect } from 'react-redux';
import MetaTags from '../../components/MetaTags/MetaTags';
import { CatalogRow, MainCol, CategoriesCol } from '../../theme/libraries/grid';
import SideMenu from '../../components/_layout/SideMenu/SideMenu';
import API from '../../services/API';
import {
  ProductsRow,
  ProductCol,
  CategoryTitle,
  CategoryPlaceholder,
} from '../../components/Category/Category';
import ProductPreview from '../../components/_helpers/product/ProductPreview';
import Pagination from '../../components/Pagination/Pagination';
import {
  brandMetaHandler,
  capitalizeFirstLetter,
  categoryMetaHandler,
  getGiftWebContentIdFromSettings,
  getTotal,
  isCartGiftsValid,
  removePTag,
  //scrollToTop,
} from '../../utilities';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import { ContainerIndent } from '../../components/_layout/Page/ContentContainer';
import CategoriesListNew from '../../components/_helpers/Categories/CategoriesListNew';
import CategorySidebarFilters from '../../components/_helpers/Categories/CategorySidebarFilters';
import CategoryFilterBar from '../../components/_helpers/Categories/CategoryFilterBar';
import MobileFilterDrawer from '../../components/_helpers/Categories/MobileFilterDrawer';
import SelectedFilters from '../../components/_helpers/Categories/SelectedFilters';
import { Content } from '../CMS/CMS';
import { Media, MediaContextProvider } from '../../theme/media';
import {
  ACTION_DEFAULT_FILTER_TYPES,
  DEFAULT_FILTER_TYPES,
  defaultSearchParameters,
  onPageChangeDefault,
  onSortChangeDefault,
  SORT_ACTION,
  SORT_CATEGORY,
} from './constants';
import { ViewportLoader } from '../../components/_helpers/Loader/ViewportLoader';
import SetCategoryPreview from '../../components/_helpers/Sets/SetCategoryPreview';
import { loadSetPopupText } from '../Home/actions';
import {
  concatSearchProductsAndSkvelkoSetsAndSoldOutProducts,
  SearchProductType,
} from '../../utilities/product';
import { theme } from '../../theme/theme';
import CategoryList from '../../components/_helpers/Categories/CategoryList';
import { rem } from 'polished';
import { forceCheck } from 'react-lazyload';
import {
  setArticleModal,
  setCurrentCategoryGroupId,
  setCurrentCategoryId,
  setSidebarCategoriesVisible,
  setSidebarCategoriesShow,
} from '../App/actions';
import { ChematCustomerType } from '../../library/ChematCustomerType';
import GiftsBannerMobile from '../../components/_helpers/Sets/GiftsBannerMobile';
import { ButtonStyled } from '../../components/_helpers/form/Button';
import * as cookie from 'react-cookies';
import IconLazy from '../../components/_helpers/Icon/IconLazy';
import { isSSR } from '@bart.sk-eshop/react-eshop-redirects/lib/action';

function itemsWord(n: number): string {
  if (n === 1) return __('položka');
  if (n >= 2 && n <= 4) return __('položky');
  return __('položiek');
}

function isCategoryInTree(categories: any[], categoryId: number): boolean {
  for (const cat of categories) {
    if (cat.category_id == categoryId) return true;
    if (cat.children?.length && isCategoryInTree(cat.children, categoryId))
      return true;
  }
  return false;
}

export function mergeCategoriesWithSubgroups(group: any) {
  const subgroups = (group.subgroups || []).map((sg) => ({
    category_id: `subgroup_${sg.id}`,
    category_name: sg.name,
    category_number: null,
    url: sg.uniqid_url || sg.categories?.[0]?.url || null,
    image: sg.image_name || sg.content?.image || null,
    children: sg.categories || [],
  }));
  const categories = group.categories || [];
  // Akcia / Novinky: 1409 (Akcia / Dobrá cena), 1545 (Novinky), subgroups, ostatné
  if (group.uniqid === 'KAT_AKCIA_SEZONA') {
    const akcia = categories.find((c) => c.category_id === 1409);
    const novinky = categories.find((c) => c.category_id === 1545);
    const rest = categories.filter(
      (c) => c.category_id !== 1409 && c.category_id !== 1545,
    );
    return [
      ...(akcia ? [akcia] : []),
      ...(novinky ? [novinky] : []),
      ...subgroups,
      ...rest,
    ];
  }
  return [...subgroups, ...categories];
}

const GlobalStyle = createGlobalStyle`
  html {
    background-color: ${theme.color.white};
    ${({ theme }) => theme.media('md')} {
      background-color: ${theme.color.background};
    }
  }
`;

export interface CategoryProps {
  categoryGroup?: any[];
  categoriesGroup?: any[];
  category?: any;
  htmlSitemap?: any;
  brand?: any;
  location: any;
  dispatch: any;
  currentCategoryGroup?: any;
  currentCategoryGroupId?: number;
  lang?: string;
  mainGroupCategory?: any;
  currentCategoryId?: number;
  currentCategory?: number;
  urlMapData?: any;
  user?: any;
  settings?: any;

  initProductsData?: any;
  initHtmlSitemp?: any;
  initCategoryGroup?: any;
  initFullCategoryGroup?: any;
  initSubtree?: any;
  currentSubgroupVirtualId?: string | null;
  sidebarCategoriesShow?: boolean;
  isHomepage?: boolean;
}

const ProductsHeader = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${rem(12)} ${rem(23)};
  margin: 0 0 ${rem(16)};
`;

const ProductsCount = styled.h2`
  margin: 0;
  font-size: ${rem(15)};
  font-weight: 400;
  line-height: ${rem(24)};
  color: ${({ theme }) => theme.color.black};
  white-space: nowrap;
  strong {
    font-weight: 600;
  }
`;

export const ProductsRowWrapper: any = styled(ProductsRow)`
  display: flex;
  flex-wrap: wrap;
  ${(props) => (props.withoutPagination ? `margin-bottom:${rem(20)}` : '')};
  ${({ theme }) => theme.media('sm')} {
    ${(props) => (props.withoutPagination ? `margin-bottom:${rem(25)}` : '')};
  }
`;

export const ProductColWrapper = styled(ProductCol)`
  & > div {
    height: 100%;
  }
`;
const FlushSideMenu = styled(SideMenu)`
  ${({ theme }) => theme.media('md')} {
    margin-top: -${rem(20)};
  }
`;

const CategoriesColTight = styled(CategoriesCol)`
  ${({ theme }) => theme.media('md')} {
    && {
      /* Keep position:relative (not sticky) so the z-index — the hover-flyout
         stacking above the product grid — still works. */
      position: relative;
      top: auto;
    }
  }
`;

const MainColTight = styled(MainCol)`
  ${({ theme }) => theme.media('md')} {
    && {
      margin-top: -${rem(12)};
    }
  }
`;

const SidebarPanel = styled.div`
  background: ${({ theme }) => theme.color.white};
  border-right: ${rem(1)} solid #e0e0e0;
  ${({ theme }) => theme.media('md')} {
    margin-top: -${rem(20)};
  }
`;

const PanelSideMenu = styled(SideMenu)`
  && {
    border: none;
    border-radius: 0;
    width: 100%;
  }
`;

const navReveal = keyframes`
  from {
    opacity: 0;
    transform: translateY(-${rem(6)});
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const RevealNav = styled.div`
  /* fill-mode backwards, NOT both: the to-state equals the natural state, but
     "both" would retain the computed transform forever, making this wrapper a
     permanent stacking context — which would trap the side menu's z-index lift
     and let the sidebar filters' positioned bits (checkboxes) paint above the
     flyout's page-dim shadow. */
  animation: ${navReveal} 0.28s ease backwards;
`;

export const CategoryDescriptionWrapper: any = styled.div`
  ${(props) => (props.isEnd ? `margin-bottom:${rem(15)}` : '')};
`;

export const DescriptinoText = styled.div`
  display: flow-root;
`;

export const ShowMoreButton = styled(ButtonStyled)`
  padding: ${rem(7)};
  margin-top: ${rem(7)};
  margin-bottom: ${rem(15)};
`;

export const InfoIcon = styled(IconLazy)`
  fill: ${({ theme }) => theme.color.blue};
  width: ${rem(20)};
  height: ${rem(20)};
  margin-right: ${rem(5)};
`;

const Category = (props: CategoryProps) => {
  const {
    category,
    brand,
    dispatch,
    currentCategoryGroup,
    currentCategoryId,
    urlMapData,
    settings,
    currentSubgroupVirtualId,
    initProductsData,
    initHtmlSitemp,
    initCategoryGroup,
    initFullCategoryGroup,
    initSubtree,
  } = props;

  Category.loaded = true;

  const [productsSearch, setProductsSearch] = useState(
    (initProductsData ? initProductsData : {}) as any,
  );
  const [categoryGroup, setCategoryGroup] = useState(
    initCategoryGroup ? initCategoryGroup : ([] as any),
  );
  const [fullCategoryGroup, setFullCategoryGroup] = useState(
    initFullCategoryGroup ? initFullCategoryGroup : (null as any),
  );
  const [subtree, setSubtree] = useState(
    initSubtree ? initSubtree : ([] as any),
  );
  const [htmlSitemap, setHtmlSitemap] = useState(
    initHtmlSitemp ? initHtmlSitemp : ([] as any),
  );
  const [loading, setLoading] = useState(false);
  const [isDescriptionOpen, setIsDescriptionOpen] = useState(false);
  const [mobileFilterOpen, setMobileFilterOpen] = useState(false);

  const { filters, addFilter, setDefaults } = useFilter({
    ...(props.category?.url === 'akcia'
      ? ACTION_DEFAULT_FILTER_TYPES
      : DEFAULT_FILTER_TYPES),
    queryLocation: props.location.query,
    dispatch: props.dispatch,
  });

  const limit = PRODUCTS_PER_PAGE;
  const sort = props.category?.url === 'akcia' ? SORT_ACTION : SORT_CATEGORY;

  const onPageChange = (page) => onPageChangeDefault(addFilter, page);
  const onSortChange = (clickedSort, clickedSortDir) =>
    onSortChangeDefault(addFilter, clickedSort, clickedSortDir);

  const selectedParameters: string[] = React.useMemo(() => {
    if (!filters.parameters) return [];
    return filters.parameters.split(',').filter((p: string) => p.length > 0);
  }, [filters.parameters]);

  const handleParametersChange = (newParams: string[]) => {
    addFilter({ name: 'page', value: '1' });
    addFilter({ name: 'parameters', value: newParams.join(',') });
  };

  const hasAttribs =
    productsSearch.attribs && productsSearch.attribs.length > 0;

  const priceBounds = {
    min: Number(productsSearch.price_min) || 0,
    max: Number(productsSearch.price_max) || 0,
  };
  const priceValue = {
    min: filters.priceMin || '',
    max: filters.priceMax || '',
  };
  const selectedFlags: string[] = React.useMemo(
    () =>
      filters.flags
        ? filters.flags.split(',').filter((f: string) => f.length > 0)
        : [],
    [filters.flags],
  );
  const flagCounts = (productsSearch.filter_counts as any) || null;
  const flagCountsBase = (productsSearch.filter_counts_base as any) || null;

  const selectedDeliveryDays: string[] = React.useMemo(
    () =>
      filters.deliveryDays
        ? filters.deliveryDays.split(',').filter((d: string) => d.length > 0)
        : [],
    [filters.deliveryDays],
  );
  const deliveryCounts = (productsSearch.delivery_counts as any) || null;
  const deliveryCountsBase =
    (productsSearch.delivery_counts_base as any) || null;

  const hasActiveFilters =
    selectedParameters.length > 0 ||
    selectedFlags.length > 0 ||
    selectedDeliveryDays.length > 0 ||
    !!priceValue.min ||
    !!priceValue.max;

  const activeFilterCount =
    selectedParameters.length +
    selectedFlags.length +
    selectedDeliveryDays.length +
    (priceValue.min || priceValue.max ? 1 : 0);

  const hasFilters = hasAttribs || productsSearch.total > 0 || hasActiveFilters;

  const handlePriceChange = (min: string, max: string) => {
    addFilter({ name: 'page', value: '1' });
    addFilter({ name: 'priceMin', value: min });
    addFilter({ name: 'priceMax', value: max });
  };

  const handleFlagsChange = (newFlags: string[]) => {
    addFilter({ name: 'page', value: '1' });
    addFilter({ name: 'flags', value: newFlags.join(',') });
  };

  const handleDeliveryDaysChange = (newDeliveryDays: string[]) => {
    addFilter({ name: 'page', value: '1' });
    addFilter({ name: 'deliveryDays', value: newDeliveryDays.join(',') });
  };

  const isFirstRender = React.useRef(true);

  React.useEffect(() => {
    return () => {
      Category.loaded = false;
    };
  }, []);

  const categoriesToggleVisible = !!category && hasFilters;

  React.useEffect(() => {
    dispatch(setSidebarCategoriesVisible(categoriesToggleVisible));
    if (categoriesToggleVisible) {
      dispatch(setSidebarCategoriesShow(true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoriesToggleVisible]);

  React.useEffect(() => {
    return () => {
      dispatch(setSidebarCategoriesVisible(false));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    if (
      !(Object.entries(filters).length === 0 && filters.constructor === Object)
    ) {
      if (isFirstRender.current) {
        isFirstRender.current = false;
        return; // skip first run
      }

      setLoading(true);

      // Priprav parametre pre produkty
      const isAkciaPage = props.category?.url === 'akcia';
      const isNewPage = props.category?.category_number === 'KAT_NEW_PRODUCT';
      let parameters: any = defaultSearchParameters(filters, limit);
      parameters = {
        ...parameters,
        hasOldprice: isAkciaPage ? 1 : 0,
        isNewActive: isNewPage ? 1 : parameters.isNewActive ? 1 : 0,
      };

      if (category && !isAkciaPage && !isNewPage) {
        parameters = {
          ...parameters,
          categoryId: category.categories_ids
            ? category.categories_ids
            : category.category_id,
        };
      }

      if (brand) {
        parameters = {
          ...parameters,
          brandId: brand.brand_id,
        };
      }

      const lamitecTesting = cookie.load('lamitec_testing');

      parameters = {
        ...parameters,
        includeSkvelkoSets: true,
        disableIgnoreLamitec: lamitecTesting == 1 ? true : false,
        categoryGroupId: currentCategoryGroup?.id,
        enableFilters: true,
      };

      const promises: Promise<any>[] = [API.searchProductsElastic(parameters)];

      if (props.category && props.category.sitemap_id) {
        const groupSearchParams: any = {
          active: '1',
          withCategories: 1,
          categoryTree: true,
          limit: 1,
          filterEmpty: true,
          filterDisabled: true,
          mergeSubgroupCategories: true,
        };
        if (props.category.type === 'subgroup') {
          groupSearchParams.hasSubgroupId = props.category.id;
        } else {
          groupSearchParams.id = props.category.id;
        }
        promises.push(
          API.loadSitemap(props.category.sitemap_id),
          API.loadCategoriesGroups(groupSearchParams),
        );
      }

      Promise.all(promises)
        .then(([productsData, sitemap, categoriesGroup]) => {
          // Spracuj produkty
          const items = concatSearchProductsAndSkvelkoSetsAndSoldOutProducts(
            productsData.products,
            productsData.skvelko_sets,
            [],
            productsData.positions,
          );
          productsData['items'] = items;
          setProductsSearch(productsData);

          // Spracuj sitemap
          if (sitemap) {
            setHtmlSitemap(sitemap);
          } else if (!props.category?.sitemap_id) {
            setHtmlSitemap(null);
          }

          // Spracuj kategórie
          if (categoriesGroup && categoriesGroup.total) {
            setCategoryGroup(
              mergeCategoriesWithSubgroups(
                categoriesGroup.catalog_category_groups[0],
              ),
            );
            setFullCategoryGroup(categoriesGroup.catalog_category_groups[0]);
            setCurrentCategoryGroupId(props.category.id);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [filters]);

  if (window) {
    React.useLayoutEffect(() => {
      forceCheck();
    });
  }

  React.useEffect(() => {
    setDefaults();
    loadSetPopupText();
  }, [category, brand]);

  React.useEffect(() => {
    getCategoryGroup().then(/*silence*/);
  }, [category]);

  React.useEffect(() => {
    if (urlMapData?.type === UrlMapTypes.CategoryGroup) {
      // For subgroup pages, show only the subgroup's categories in the grid
      if (category?.type === 'subgroup' && fullCategoryGroup?.subgroups) {
        const sg = fullCategoryGroup.subgroups.find(
          (s) => s.id === category.id,
        );
        setSubtree(sg?.categories || []);
      } else {
        setSubtree(categoryGroup);
      }
    } else if (currentCategoryId) {
      const matchingSubgroup = fullCategoryGroup?.subgroups?.find((sg) =>
        isCategoryInTree(sg.categories || [], currentCategoryId),
      );
      API.loadSubTree(currentCategoryId, {
        filterEmpty: true,
        disabledCategoryGroupId:
          matchingSubgroup?.id ?? currentCategoryGroup?.id,
      }).then((r) => {
        setSubtree(r);
      });
    }
  }, [category, categoryGroup, fullCategoryGroup]);

  const onGiftOpen = async () => {
    dispatch(setArticleModal(getGiftWebContentIdFromSettings(settings)));
  };

  const onDescriptionButtonClick = async () => {
    setIsDescriptionOpen(!isDescriptionOpen);
  };

  const getCategoryGroup = async () => {
    // For subgroups, load the parent group (for side menu) via hasSubgroupId
    if (category?.type === 'subgroup' && category?.id) {
      API.loadCategoriesGroups({
        active: '1',
        withCategories: 1,
        categoryTree: true,
        limit: 1,
        hasSubgroupId: category.id,
        filterEmpty: true,
        filterDisabled: true,
        mergeSubgroupCategories: true,
      }).then((categoriesGroup) => {
        if (categoriesGroup.total) {
          setCategoryGroup(
            mergeCategoriesWithSubgroups(
              categoriesGroup.catalog_category_groups[0],
            ),
          );
          setFullCategoryGroup(categoriesGroup.catalog_category_groups[0]);
        }
      });
      return;
    }
    if (props.currentCategoryGroup && props.currentCategoryGroup.categories) {
      setCategoryGroup(
        mergeCategoriesWithSubgroups(props.currentCategoryGroup),
      );
      setFullCategoryGroup(props.currentCategoryGroup);
      return;
    }
    if (!category || !category.url || !category.category_id) {
      return;
    }
    let categoryId = category.category_id;
    const urlMap = category.url.split('/')[0];
    if (urlMap !== category.url) {
      const urlMapData = await API.getUrlMap(
        {
          url: category.url.replace(/^\//, ''),
        },
        {
          xAcceptLanguage: props.lang,
        },
      );
      if (urlMapData && urlMapData.data && urlMapData.data.category_id) {
        categoryId = urlMapData.data.category_id;
      }
    }
    if (categoryId) {
      API.loadCategoriesGroups({
        active: '1',
        withCategories: 1,
        categoryTree: true,
        limit: 1,
        categoryId: categoryId,
        filterEmpty: true,
        filterDisabled: true,
        mergeSubgroupCategories: true,
      }).then((categoriesGroup) => {
        if (categoriesGroup.total) {
          setCategoryGroup(
            mergeCategoriesWithSubgroups(
              categoriesGroup.catalog_category_groups[0],
            ),
          );
          setFullCategoryGroup(categoriesGroup.catalog_category_groups[0]);
        } else {
          API.loadCategoriesGroups({
            active: '1',
            withCategories: 1,
            categoryTree: true,
            limit: 100,
            categoryIdAndParent: categoryId,
            filterEmpty: true,
            filterDisabled: true,
            mergeSubgroupCategories: true,
          }).then((categoriesGroup) => {
            if (categoriesGroup.total) {
              setCategoryGroup(
                mergeCategoriesWithSubgroups(
                  categoriesGroup.catalog_category_groups[0],
                ),
              );
              setFullCategoryGroup(categoriesGroup.catalog_category_groups[0]);
            }
          });
        }
      });
    }
  };

  const isSchoolWebCategory =
    category &&
    category.parent_categories &&
    category?.parent_categories[0]?.category_id === 932
      ? true
      : false;

  const renderCategoryDesctiption = (body, shortBody) => {
    if (shortBody && body) {
      return (
        <CategoryDescriptionWrapper isEnd={isDescriptionOpen ? true : false}>
          <DescriptinoText
            dangerouslySetInnerHTML={{
              __html: shortBody,
            }}
          />

          {isDescriptionOpen ? (
            <ShowMoreButton onClick={onDescriptionButtonClick}>
              {' '}
              <InfoIcon icon="info" />
              {__('Menej informácií')}
            </ShowMoreButton>
          ) : (
            <ShowMoreButton onClick={onDescriptionButtonClick}>
              {' '}
              <InfoIcon icon="info" />
              {__('Viac informácií')}
            </ShowMoreButton>
          )}

          {isDescriptionOpen ? (
            <DescriptinoText
              dangerouslySetInnerHTML={{
                __html: body,
              }}
            />
          ) : (
            <></>
          )}
        </CategoryDescriptionWrapper>
      );
    } else if (shortBody) {
      return (
        <CategoryDescriptionWrapper isEnd={true}>
          <DescriptinoText
            dangerouslySetInnerHTML={{
              __html: shortBody,
            }}
          />
        </CategoryDescriptionWrapper>
      );
    } else if (body) {
      return (
        <CategoryDescriptionWrapper isEnd={true}>
          <DescriptinoText
            dangerouslySetInnerHTML={{
              __html: body,
            }}
          />
        </CategoryDescriptionWrapper>
      );
    }

    return <></>;
  };

  const getMainCol = () => {
    const paginationTotal = getTotal(productsSearch);
    const shortBody =
      category &&
      category.content &&
      category.content.length &&
      category.content[0].draft !== true &&
      typeof category.content[0].json_content?.short_body === 'string'
        ? removePTag(category.content[0].json_content?.short_body)
        : null;
    const body =
      category &&
      category.content &&
      category.content.length &&
      category.content[0].draft !== true &&
      typeof category.content[0].json_content?.body === 'string'
        ? removePTag(category.content[0].json_content?.body)
        : null;
    return (
      <div>
        {category &&
        category.category_name &&
        category.category_name === 'Nezaradene' ? (
          <MetaTags tags={{ robots: 'noindex' }} />
        ) : (
          ''
        )}
        {htmlSitemap &&
        htmlSitemap.content &&
        typeof htmlSitemap.content.json_content.body === 'string' ? (
          <React.Fragment>
            <Content
              dangerouslySetInnerHTML={{
                __html: htmlSitemap.content.json_content.body,
              }}
            />
          </React.Fragment>
        ) : (
          ''
        )}

        {renderCategoryDesctiption(body, shortBody)}

        <CategoryList categories={subtree} user={props.user} />
        <Media lessThan="lg">
          {hasFilters && (
            <CategoryFilterBar
              filterCount={activeFilterCount}
              onOpenFilter={() => setMobileFilterOpen(true)}
              sort={sort}
              sortCurrent={filters.sort}
              sortDirCurrent={filters.sortDir}
              onSortChange={onSortChange}
            />
          )}
        </Media>
        <ProductsHeader>
          <ProductsCount>
            <strong>{__('Produkty')}:</strong> {productsSearch.total || 0}{' '}
            {itemsWord(productsSearch.total || 0)}
          </ProductsCount>
          <SelectedFilters
            attribs={productsSearch.attribs || []}
            selectedParameters={selectedParameters}
            onParametersChange={handleParametersChange}
            selectedFlags={selectedFlags}
            onFlagsChange={handleFlagsChange}
            priceValue={priceValue}
            onPriceChange={handlePriceChange}
            selectedDeliveryDays={selectedDeliveryDays}
            onDeliveryDaysChange={handleDeliveryDaysChange}
          />
        </ProductsHeader>
        <ViewportLoader loading={loading}>
          {productsSearch.total > limit ? (
            <Filter
              sort={sort}
              onSortChange={onSortChange}
              paginationCurrent={filters.page}
              paginationTotal={paginationTotal}
              onPageChanged={onPageChange}
              isSearch={false}
              isSortable={true}
              sortCurrent={filters.sort}
              sortDirCurrent={filters.sortDir}
              hideMobileSort={true}
              hideMobilePagination={true}
              hideCompactPagination={true}
            />
          ) : (
            <Filter
              sort={sort}
              onSortChange={onSortChange}
              isSearch={false}
              isSortable={true}
              sortCurrent={filters.sort}
              sortDirCurrent={filters.sortDir}
              hideMobileSort={true}
              hideMobilePagination={true}
            />
          )}
          {productsSearch.items && productsSearch.items.length ? (
            <>
              <ProductsRowWrapper
                withoutPagination={!(productsSearch.total > limit)}
              >
                {productsSearch.items.map((item) => {
                  if (item.type === SearchProductType.SKVELKO_SET) {
                    return (
                      <ProductColWrapper key={item.item.id}>
                        <SetCategoryPreview skvelkoSet={item.item} />
                      </ProductColWrapper>
                    );
                  } else {
                    return (
                      <ProductColWrapper key={item.item.product_id}>
                        <ProductPreview
                          product={item.item}
                          fromSchoolWebCategory={isSchoolWebCategory}
                          setLoading={(loading) => setLoading(loading)}
                        />
                      </ProductColWrapper>
                    );
                  }
                })}
              </ProductsRowWrapper>
              {productsSearch.total > limit && (
                <Pagination
                  current={filters.page}
                  total={paginationTotal}
                  onPageChanged={onPageChange}
                />
              )}
            </>
          ) : loading ? (
            ''
          ) : (
            <CategoryPlaceholder text={__('Žiadné produkty sa nenašli')} />
          )}
        </ViewportLoader>
        <Media lessThan="lg">
          <MobileFilterDrawer
            open={mobileFilterOpen}
            onClose={() => setMobileFilterOpen(false)}
            attribs={productsSearch.attribs || []}
            selectedParameters={selectedParameters}
            onParametersChange={handleParametersChange}
            priceBounds={priceBounds}
            priceValue={priceValue}
            onPriceChange={handlePriceChange}
            selectedDeliveryDays={selectedDeliveryDays}
            deliveryCounts={deliveryCounts}
            deliveryCountsBase={deliveryCountsBase}
            onDeliveryDaysChange={handleDeliveryDaysChange}
            selectedFlags={selectedFlags}
            flagCounts={flagCounts}
            flagCountsBase={flagCountsBase}
            onFlagsChange={handleFlagsChange}
          />
        </Media>
      </div>
    );
  };

  let categoryName = category ? category.category_name : '';

  let htmlSitemapName = null;
  if (htmlSitemap && htmlSitemap.content) {
    htmlSitemapName = htmlSitemap.content.json_content.name;
  }
  const categoryGroupName = htmlSitemapName
    ? htmlSitemapName
    : currentCategoryGroup
    ? currentCategoryGroup.name
    : '';
  let brandName = brand ? brand.brand_name : '';

  const items: any = [];
  if (category) {
    if (category.parent_categories && category.parent_categories.length) {
      const stopCategoryIds: number[] = [];
      // Only show subgroup in breadcrumbs when user is actually in a subgroup context.
      // currentSubgroupVirtualId is set when user clicked a category from inside a subgroup.
      const matchingSubgroup = currentSubgroupVirtualId
        ? fullCategoryGroup?.subgroups?.find(
            (sg) =>
              `subgroup_${sg.id}` === currentSubgroupVirtualId &&
              isCategoryInTree(sg.categories || [], category.category_id),
          )
        : undefined;
      if (
        fullCategoryGroup &&
        fullCategoryGroup.categories &&
        fullCategoryGroup.categories.length
      ) {
        for (const fullCategoryGroupCategory of fullCategoryGroup.categories) {
          stopCategoryIds.push(fullCategoryGroupCategory.category_id);
        }

        items.push({
          name: capitalizeFirstLetter(fullCategoryGroup.name),
          url: fullCategoryGroup.uniqid_url,
        });
      }

      if (matchingSubgroup) {
        for (const sgCat of matchingSubgroup.categories || []) {
          stopCategoryIds.push(sgCat.category_id);
        }
      }

      let brEnabled = false;
      for (const parentCategory of category.parent_categories) {
        if (stopCategoryIds.includes(parentCategory.category_id)) {
          brEnabled = true;
        }

        if (brEnabled) {
          items.push({
            name: capitalizeFirstLetter(parentCategory.category_name),
            url: items.length !== 0 ? parentCategory.url : null,
          });
        }
      }

      if (currentCategoryGroup) {
        items.splice(0, 1, {
          name: capitalizeFirstLetter(currentCategoryGroup.name),
          url: currentCategoryGroup.uniqid_url,
        });
      }

      if (matchingSubgroup) {
        items.splice(1, 0, {
          name: capitalizeFirstLetter(matchingSubgroup.name),
          url:
            matchingSubgroup.uniqid_url ||
            matchingSubgroup.categories?.[0]?.url ||
            null,
        });
      }
    } else if (category.name && category.uniqid_url) {
      categoryName = category.name;
      category.url = category.uniqid_url;
    }

    items.push({
      name: capitalizeFirstLetter(categoryName),
      url: category.url,
    });

    if (
      category.uniqid === 'KAT_AKCIA_SEZONA' &&
      props.user &&
      props.user.skvelko_type !== ChematCustomerType.RETAIL
    ) {
      categoryName = __('Novinky / Sezóna');
      if (items && items.length >= 1) {
        items[0].name = __('Novinky / Sezóna');
      }
    }

    return (
      <MediaContextProvider>
        <ContainerIndent className="base">
          <GlobalStyle />
          {!props.isHomepage && (
            <MetaTags tags={categoryMetaHandler(category, 'sk', 'Daffer.sk')} />
          )}
          <CatalogRow>
            <CategoriesColTight>
              {/* One continuous panel (figma): category nav + filter sections.
                  CategoriesCol is display:none below md, so this is desktop-only;
                  the <Media lessThan="lg"> block below renders filters on mobile. */}
              <SidebarPanel>
                {/* Category nav: always shown when the category has no filters;
                    when it has filters it is hidden by default and toggled via
                    the header "Zobraziť/Skryť kategórie" button (redux). */}
                {(!hasFilters || props.sidebarCategoriesShow) && (
                  <RevealNav>
                    <PanelSideMenu
                      categoriesGroup={props.categoriesGroup || []}
                      dispatch={dispatch}
                      currentPath={props.location?.pathname}
                      activeGroupId={fullCategoryGroup?.id}
                      furniture={isFurnitureSection(
                        props.categoriesGroup,
                        props.currentCategoryGroupId,
                        props.currentCategoryId,
                      )}
                    />
                  </RevealNav>
                )}
                {hasFilters && (
                  <CategorySidebarFilters
                    attribs={productsSearch.attribs || []}
                    selectedParameters={selectedParameters}
                    onParametersChange={handleParametersChange}
                    priceBounds={priceBounds}
                    priceValue={priceValue}
                    onPriceChange={handlePriceChange}
                    selectedDeliveryDays={selectedDeliveryDays}
                    deliveryCounts={deliveryCounts}
                    deliveryCountsBase={deliveryCountsBase}
                    onDeliveryDaysChange={handleDeliveryDaysChange}
                    selectedFlags={selectedFlags}
                    flagCounts={flagCounts}
                    flagCountsBase={flagCountsBase}
                    onFlagsChange={handleFlagsChange}
                  />
                )}
              </SidebarPanel>
            </CategoriesColTight>

            <Media lessThan="lg">
              {isCartGiftsValid(settings, props.user) ? (
                <GiftsBannerMobile
                  withoutPadding={true}
                  onLinkClick={onGiftOpen}
                />
              ) : (
                <></>
              )}
              {/* The mobile filters now live in a slide-in drawer opened from the
                  CategoryFilterBar (rendered inside getMainCol), not inline here. */}
            </Media>

            <MainColTight>
              <Breadcrumbs items={items} />
              <CategoryTitle
                name={
                  categoryName
                    ? capitalizeFirstLetter(categoryName)
                    : categoryGroupName
                    ? capitalizeFirstLetter(categoryGroupName)
                    : ''
                }
              />
              {getMainCol()}
            </MainColTight>
          </CatalogRow>
        </ContainerIndent>
      </MediaContextProvider>
    );
  } else {
    return (
      <MediaContextProvider>
        <ContainerIndent className="base">
          <GlobalStyle />
          <MetaTags tags={brandMetaHandler(brand, 'sk', 'Daffer.sk')} />
          <CatalogRow>
            <CategoriesColTight>
              <FlushSideMenu
                categoriesGroup={props.categoriesGroup || []}
                dispatch={dispatch}
                currentPath={props.location?.pathname}
              />
              <CategoriesListNew
                dispatch={dispatch}
                categoryGroup={props.mainGroupCategory}
              />
            </CategoriesColTight>
            <MainColTight>
              <Breadcrumbs items={[{ name: brandName, url: brand.url }]} />
              {getMainCol()}
            </MainColTight>
          </CatalogRow>
        </ContainerIndent>
      </MediaContextProvider>
    );
  }
};

Category.loaded = false;

Category.getInitialProps = async (props) => {
  if (props.categoryType === 'group') {
    props.dispatch(setCurrentCategoryId(null));
  }

  if (!isSSR() && Category.loaded) {
    return;
  }

  const defaultFilterTypes = (
    props.category?.url === 'akcia'
      ? ACTION_DEFAULT_FILTER_TYPES
      : DEFAULT_FILTER_TYPES
  )?.filterTypes;

  // Prepare filters first (synchronous operations)
  const input = {
    ...(props.category?.url === 'akcia'
      ? ACTION_DEFAULT_FILTER_TYPES
      : DEFAULT_FILTER_TYPES),
    queryLocation: props.location.query,
    dispatch: props.dispatch,
  };

  const filters = defaultFilterTypes.reduce((acc, item) => {
    acc[item.name] = item.defaultValue;
    return acc;
  }, {});

  if (input.queryLocation) {
    Object.keys(input.queryLocation).forEach((name) => {
      const filterType = input.filterTypes.find(
        (findFilterType) => findFilterType.urlName === name,
      );
      if (filterType) {
        filters[filterType.name] = input.queryLocation[name];
      }
    });
  }

  // Prepare search parameters
  const isAkciaPage = props.category?.url === 'akcia';
  const isNewPage = props.category?.category_number === 'KAT_NEW_PRODUCT';
  let parameters: any = defaultSearchParameters(filters, PRODUCTS_PER_PAGE);
  parameters = {
    ...parameters,
    hasOldprice: isAkciaPage ? 1 : 0,
    isNewActive: isNewPage ? 1 : parameters.isNewActive ? 1 : 0,
  };

  if (props.category && !isAkciaPage && !isNewPage) {
    parameters = {
      ...parameters,
      categoryId: props.category.categories_ids
        ? props.category.categories_ids
        : props.category.category_id,
    };
  }

  if (props.brand) {
    parameters = {
      ...parameters,
      brandId: props.brand.brand_id,
    };
  }

  const lamitecTesting = cookie.load('lamitec_testing');

  parameters = {
    ...parameters,
    includeSkvelkoSets: true,
    disableIgnoreLamitec: lamitecTesting == 1 ? true : false,
    categoryGroupId: props.currentCategoryGroup?.id,
    enableFilters: true,
  };

  // Load all data in parallel for better performance
  const parallelRequests: Promise<any>[] = [
    API.searchProductsElastic(parameters), // 0: products
  ];

  // Add sitemap and category groups requests if needed
  if (props.category && props.category.sitemap_id) {
    const ssrGroupSearchParams: any = {
      active: '1',
      withCategories: 1,
      categoryTree: true,
      limit: 1,
      filterEmpty: true,
      filterDisabled: true,
      mergeSubgroupCategories: true,
    };
    if (props.category.type === 'subgroup') {
      ssrGroupSearchParams.hasSubgroupId = props.category.id;
    } else {
      ssrGroupSearchParams.id = props.category.id;
    }
    parallelRequests.push(
      API.loadSitemap(props.category.sitemap_id), // 1: sitemap
      API.loadCategoriesGroups(ssrGroupSearchParams), // 2: category groups
    );
  }

  // Add subtree request if needed
  if (
    props.urlMapData?.type !== UrlMapTypes.CategoryGroup &&
    props.currentCategoryId
  ) {
    parallelRequests.push(
      API.loadSubTree(props.currentCategoryId, {
        filterEmpty: true,
        disabledCategoryGroupId: props.currentCategoryGroup?.id,
      }), // 3: subtree
    );
  }

  // Execute all requests in parallel
  const results = await Promise.all(parallelRequests);

  // Process search products data
  const searchProductsData = results[0];
  const items = concatSearchProductsAndSkvelkoSetsAndSoldOutProducts(
    searchProductsData.products,
    searchProductsData.skvelko_sets,
    [],
    searchProductsData.positions,
  );
  searchProductsData['items'] = items;
  const productsData = searchProductsData;

  // Process sitemap and category groups if loaded
  let htmlSitemap: any = null;
  let categoryGroup: any = null;
  let fullCategoryGroup: any = null;

  if (props.category && props.category.sitemap_id) {
    htmlSitemap = results[1];
    const categoriesGroup = results[2];

    if (categoriesGroup?.catalog_category_groups?.[0]) {
      categoryGroup = mergeCategoriesWithSubgroups(
        categoriesGroup.catalog_category_groups[0],
      );
      fullCategoryGroup = categoriesGroup.catalog_category_groups[0];
      setCurrentCategoryGroupId(props.category.id);
    }
  }

  // Process subtree
  let subtree: any = [];
  if (props.urlMapData?.type === UrlMapTypes.CategoryGroup) {
    // For subgroup pages, show only the subgroup's categories in the grid
    if (props.category?.type === 'subgroup' && fullCategoryGroup?.subgroups) {
      const sg = fullCategoryGroup.subgroups.find(
        (s) => s.id === props.category.id,
      );
      subtree = sg?.categories || [];
    } else {
      subtree = categoryGroup || [];
    }
  } else if (props.currentCategoryId) {
    // Find subtree in results - it's at index 3 if sitemap was loaded, otherwise 1
    const subtreeIndex = props.category && props.category.sitemap_id ? 3 : 1;
    subtree = results[subtreeIndex] || [];
  }

  return {
    initProductsData: productsData,
    initHtmlSitemp: htmlSitemap,
    initCategoryGroup: categoryGroup,
    initFullCategoryGroup: fullCategoryGroup,
    initSubtree: subtree,
  };
};

const mapStateToProps = (state) => {
  return {
    categoriesGroup: state.general.categoriesGroup,
    mainGroupCategory: state.general.mainGroupCategory,
    currentCategoryGroup: state.general.currentCategoryGroup,
    currentCategoryGroupId: state.general.currentCategoryGroupId,
    currentCategoryId: state.general.currentCategoryId,
    currentCategory: state.general.currentCategory,
    urlMapData: state.general.urlMapData,
    user: state.auth.user,
    settings: state.general.settings,
    currentSubgroupVirtualId: state.general.currentSubgroupVirtualId ?? null,
    sidebarCategoriesShow: state.general.sidebarCategoriesShow,
  };
};

export default connect(mapStateToProps)(Category);
